import { render, staticRenderFns } from "./VariantSifterMenuBar.vue?vue&type=template&id=731cad68&scoped=true&"
import script from "./VariantSifterMenuBar.vue?vue&type=script&lang=js&"
export * from "./VariantSifterMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterMenuBar.vue?vue&type=style&index=0&id=731cad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731cad68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731cad68')) {
      api.createRecord('731cad68', component.options)
    } else {
      api.reload('731cad68', component.options)
    }
    module.hot.accept("./VariantSifterMenuBar.vue?vue&type=template&id=731cad68&scoped=true&", function () {
      api.rerender('731cad68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterMenuBar.vue"
export default component.exports